module.exports = __webpack_public_path__ + "33f168a5.png";